var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CabeceraModal",
    {
      attrs: { titulo: "Ver Devolución" },
      on: {
        cerrar: function($event) {
          return _vm.$emit("cerrarVer")
        }
      }
    },
    [
      _c("div", { staticClass: "cabeceraDevolucion" }, [
        _c(
          "div",
          { staticClass: "botones" },
          [
            _c(
              "v-btn",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mostrarBtnVolver,
                    expression: "mostrarBtnVolver"
                  }
                ],
                staticClass: "cabeceraDevolucionBtnVolver",
                on: { click: _vm.volv }
              },
              [_c("span", [_vm._v("Volver")])]
            ),
            _c(
              "v-btn",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.mostrarBtnContinuar,
                    expression: "mostrarBtnContinuar"
                  }
                ],
                staticClass: "cabeceraDevolucionBtnContinuar",
                on: { click: _vm.cont }
              },
              [_c("span", [_vm._v("Continuar")])]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }